import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDeleteOutline24 = function SvgDeleteOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4H5c-.274 0-.5.225-.5.5V6h15V4.5A.498.498 0 0 0 19 4h-3.5zM19 3h.017a1.49 1.49 0 0 1 1.065.462c.259.27.418.636.418 1.038v2a.5.5 0 0 1-.5.5h-.5v14.5c0 1.379-1.12 2.5-2.5 2.5H7a2.502 2.502 0 0 1-2.5-2.5V7H4a.5.5 0 0 1-.5-.5v-2C3.5 3.673 4.173 3 5 3h2.5V1.5C7.5.673 8.173 0 9 0h6c.827 0 1.5.673 1.5 1.5V3H19zM5.5 7h13v14.5c0 .827-.673 1.5-1.5 1.5H7c-.827 0-1.5-.673-1.5-1.5V7zm3-5.5V3h7V1.5c0-.275-.225-.5-.5-.5H9c-.274 0-.5.225-.5.5zm1 18a.5.5 0 0 1-1 0v-10a.5.5 0 0 1 1 0v10zm2.5.5a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-1 0v10a.5.5 0 0 0 .5.5zm3.5-.5a.5.5 0 0 1-1 0v-10a.5.5 0 0 1 1 0v10z",
    fill: "currentColor"
  })));
};

var DeleteOutline24Svg = SvgDeleteOutline24;

export { DeleteOutline24Svg as default };
//# sourceMappingURL=DeleteOutline24.svg.js.map
